<template>
  <v-main class="login-page">
    <v-card>
      <h1 class="display-1 mb-5">Heppi Suporte<br><small>Esqueci a senha</small></h1>
      <template v-if="fields.token.value && sended">
        <v-card-text>
          <p>Pronto! Sua senha foi atualizada. Agora você só precisa fazer o login.</p>
          <v-btn block color="primary" :disabled="sending" :to="{ name: 'login' }">Fazer o login</v-btn>
        </v-card-text>
      </template>
      <template v-else-if="fields.token.value">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-text-field
            label="E-mail"
            :value="fields.email.value"
            disabled
            type="email"
            outlined dense
          ></v-text-field>
          <v-text-field
            label="Senha nova"
            v-model="fields.password.value"
            :rules="[...fields.password.rules, ...fields.password.apiErrors]"
            type="password"
            outlined dense
          ></v-text-field>
          <v-text-field
            label="Confirme a senha nova"
            v-model="fields.password_confirmation.value"
            :rules="[...fields.password_confirmation.rules, ...confirmPasswordRules, ...fields.password_confirmation.apiErrors]"
            type="password"
            outlined dense
          ></v-text-field>
          <v-btn block color="primary" :disabled="sending" :loading="sending" @click="resetPassword()">Salvar senha nova</v-btn>
          <template v-if="errorMessage">
            <br>
            <v-btn block text color="primary" :disabled="sending" :to="{ name: 'forgotPassword' }">Solicitar novo e-mail</v-btn>
          </template>
          <template>
            <br>
            <v-btn block text color="primary" :disabled="sending" :to="{ name: 'login' }">Voltar para o login</v-btn>
          </template>
        </v-form>
      </template>
      <template v-else-if='sended'>
        <v-card-text>
          <p>Foi enviado um e-mail para {{ fields.email.value }} com instruções de como recuperar a senha. Verifique sua caixa de entrada.</p>
          <v-btn block color="primary" :disabled="sending" :loading="sending" @click="sendEmail()">Tentar novamente</v-btn>
          <br>
          <v-btn block text color="primary" :disabled="sending" :to="{ name: 'login' }">Voltar para o login</v-btn>
        </v-card-text>
      </template>
      <template v-else>
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <p>Informe abaixo seu email:</p>
          <v-text-field
            label="E-mail"
            v-model="fields.email.value"
            :rules="[...fields.email.rules, ...fields.email.apiErrors]"
            type="email"
            outlined dense
          ></v-text-field>
          <v-btn block color="primary" :disabled="sending" :loading="sending" @click="sendEmail()">Recuperar senha</v-btn>
          <br>
          <v-btn block text color="primary" :disabled="sending" :to="{ name: 'login' }">Voltar para o login</v-btn>
        </v-form>
      </template>
    </v-card>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'forgotPassword',
  data: () => ({
    fields: {
      token: {
        value: ''
      },
      email: {
        value: '',
        rules: [
          v => !!v || 'O e-mail é obrigatório',
          v => /.+@.+\..+/.test(v) || 'Precisa ser um e-mail válido'
        ],
        apiErrors: []
      },
      password: {
        value: '',
        rules: [
          v => !!v || 'A senha é obrigatória'
        ],
        apiErrors: []
      },
      password_confirmation: {
        value: '',
        rules: [
          v => !!v || 'A confirmação de senha é obrigatória'
        ],
        apiErrors: []
      }
    },
    sending: false,
    sended: false,
    errorMessage: null
  }),
  computed: {
    confirmPasswordRules () {
      return [
        v => (this.fields.password.value === this.fields.password_confirmation.value) || 'A senha e a confirmação não conferem'
      ]
    },
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  watch: {
    '$route.query.token' (val) {
      if (!val) this.fields.token.value = ''
    }
  },
  methods: {
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    sendEmail () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        axios.post('forgot-password', vue.apiData)
          .then(response => {
            vue.sending = false
            vue.sended = true
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.status === 400) {
              vue.errorMessage = error.response.data.message
            } else if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    },
    resetPassword () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        axios.post('reset-password', vue.apiData)
          .then(response => {
            vue.sending = false
            vue.sended = true
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.status === 400) {
              vue.errorMessage = 'O token não está mais disponível para recuperar a senha. Você precisa solicitar outra recuperação de senha.'
            } else if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  created () {
    if (this.$route.query.token) this.fields.token.value = this.$route.query.token
    if (this.$route.query.email) this.fields.email.value = this.$route.query.email
  }
}
</script>
